<p-confirmDialog key="add" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Main Form-->
<div class="MainGrid2Col">
	<label>Student ID:</label>
	<label class="InfoText">{{ StudentID }}</label>

	<label>Student Name:</label>
	<label class="InfoText">{{ StudentName }}</label>

	<label>Balance:</label>
	<label class="InfoText">{{ CurrentBalanceDesc }}</label>

	<label>Fine Type:</label>
	<select class="form-control" name="FineType" [(ngModel)]="FineType" (ngModelChange)="onFineTypeChange($event)">
		<option *ngFor="let r of lstFineType" [ngValue]="r">
			{{ r.AccountDebitTypeDesc }}
		</option>
	</select>

	<label>Amount:</label>
	<!-- <p-inputNumber [min]="0" [max]="99.99" [(ngModel)]="FineAmount" (ngModelChange)="onFineAmountChange($event)" mode="currency" currency="USD" locale="en-US" step="0.01" [showButtons]="true"></p-inputNumber> -->
	<input class="form-control" type="number" [min]="0" [max]="99.99" step="0.01" [(ngModel)]="FineAmount" (ngModelChange)="onFineAmountChange($event)" />

	<label>Comments:</label>
	<textarea class="TextArea" [(ngModel)]="Comments" rows="5"></textarea>

	<label>Updated Balance:</label>
	<label class="InfoText">{{ UpdatedBalance }}</label>
</div>

<!--Buttons-->
<div class="Buttons">
	<button class="btn btn-primary" (click)="onAdd()">Add</button>
	<button class="btn btn-primary" (click)="onClose()">Close</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
